export enum UserAuthenticationType {
    FormsLogin = 1,
    AdLogin = 2
}
